module.exports = __webpack_public_path__ + "media/images/olympic_rm_logo_no_bar-36f541ceffbf96abb88dd252c49c7193.png";